import { createMarkerPopup } from 'components/Map/NewJobMarkers/utils/markerPopupUtils';
import { escapeHtml } from 'utils/security';
import { isPointDepot } from 'utils/map/MapFeatureFilters';

const MARKER_HEIGHT = 48;

export function attachStartEndHoverEvents(marker, translationsRef, map) {
  createMarkerPopup(marker, map, MARKER_HEIGHT, (data) => {
    const { depotMarkerTrans, returnLocationMarkerTrans } = translationsRef.current.map;
    const address = data?.address
      ? `<div style="font-weight:bold;">${escapeHtml(data.address)}</div>`
      : '';
    const labels = data?.labels?.length
      ? `<div style="font-weight:bold;">${data.labels.map((label) => escapeHtml(label)).join('<br/>')}</div>`
      : '';
    return `${address}${labels}${
      isPointDepot({ properties: data }) ? depotMarkerTrans : returnLocationMarkerTrans
    }`;
  });
}
